module.exports = __webpack_public_path__ + "img/5.c9a96ca3.png";